import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M224 0H106.667V1339.83H1700.04L1223.57 1835.48L1304.82 1920L1920 1280.06L1304.82 640L1223.57 724.52L1700.04 1220.29H224V0Z"
});

var IconArrowNestLine = /*#__PURE__*/function (_Component) {
  _inherits(IconArrowNestLine, _Component);

  var _super = _createSuper(IconArrowNestLine);

  function IconArrowNestLine() {
    _classCallCheck(this, IconArrowNestLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconArrowNestLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconArrowNest",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconArrowNestLine.displayName = "IconArrowNestLine";
  return IconArrowNestLine;
}(Component);

IconArrowNestLine.glyphName = 'arrow-nest';
IconArrowNestLine.variant = 'Line';
IconArrowNestLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconArrowNestLine;
export { IconArrowNestLine };